export class BadRequestError extends Error {
    public name = 'BadRequestError';
}
